<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs>
<app-shipment-filter-bar   [tab]="shipmentTab" ></app-shipment-filter-bar>
<section id="tabs" class="project-tab ipad-pro">
    <div  class=" d-lg-none gird-div mb-display-top pl-3 pr-3">
        <div>
            <span  class="grid-icon css-sort ">
                <span  class="mr-2">
                  Sort by :
                </span>
                <select class="dropdownClass-mb" (change)="selectChangeHandler($event)">
                  <option value="ETA_DESC">ETA (newest first) - Default</option>
                  <option value="ETA_ASC">ETA (oldest first)</option>
                  <option value="ETB_DESC">ETB (newest first)</option>
                  <option value="ETB_ASC">ETB (oldest first)</option>
                  <option value="ETD_DESC">ETD (newest first)</option>
                  <option value="ETD_ASC">ETD (oldest first)</option>
                  <option value="ETAD_DESC">ETAD (newest first)</option>
                  <option value="ETAD_ASC">ETAD (oldest first)</option>
                  <option value="BOL_DESC">BOL (newest first)</option>
                  <option value="BOL_ASC">BOL (oldest first)</option>
                </select>
              </span>
        </div>
       
      
      </div>
    <div *ngIf=" !enableLoader" class="container" >
        <!-- Some CHanges -->
        <div class="row d-flex justify-content-between px-2 pt-4" >
          <div class="col-lg-3 tabDiv">
            <nav class="product-tab ">
              <div class="nav nav-fill nav-tabs pe-auto" id="nav-tab" role="tablist">
                
                <div class="nav-item nav-link active tab-bar strong" [class.active]="activeTab === 'upcoming'" id="nav-profile-tab" data-toggle="tab"
                  role="tab" aria-controls="nav-profile" aria-selected="true" (click)="changeTab('upcoming')"
                 > {{'shipment.Upcoming'| cxTranslate}}
                </div>
                <div class="nav-item nav-link  tab-bar strong" [class.active]="activeTab === 'inprogress'" id="nav-home-tab" data-toggle="tab"
                  role="tab" aria-controls="nav-home" aria-selected="false"(click)="changeTab('inprogress')"
                 >{{'shipment.InProgress'| cxTranslate}}
                </div>
                <div class="nav-item nav-link  tab-bar strong" [class.active]="activeTab === 'completed'" id="nav-home-tab" data-toggle="tab"
                  role="tab" aria-controls="nav-home" aria-selected="false"(click)="changeTab('completed')"
                 >{{'shipment.Completed'| cxTranslate}}
                </div>
              </div>
            </nav>
          </div>
          <div  class=" mobdisplay gird-div display-top mt-n1 d-none d-md-block d-lg-block-filter-bar">
            <span *ngIf="true" class="grid-icon css-sort pr-5">
              <span  class="mr-2">
                Sort by :
              </span>
              <select class="dropdownClass" (change)="selectChangeHandler($event)">
                <option value="ETA_DESC">ETA (newest first) - Default</option>
                <option value="ETA_ASC">ETA (oldest first)</option>
                <option value="ETB_DESC">ETB (newest first)</option>
                <option value="ETB_ASC">ETB (oldest first)</option>
                <option value="ETD_DESC">ETD (newest first)</option>
                <option value="ETD_ASC">ETD (oldest first)</option>
                <option value="ETAD_DESC">ETAD (newest first)</option>
                <option value="ETAD_ASC">ETAD (oldest first)</option>
                <option value="BOL_DESC">BOL (newest first)</option>
                <option value="BOL_ASC">BOL (oldest first)</option>
              </select>
            </span>
            <span class="grid-icon ml-3">Display as:
                <img class="grid-icon" title="grid" [src]='gridSrc' (click)="viewGrid()" >
                <img class="list-icon" title="list" [src]='listSrc' (click)=" viewList()">
             
            </span>
          </div>
          
        </div>
        <div class="border-bottom"></div>
        <!-- <hr> -->
    </div>
   
    <div *ngIf="enableLoader" id="loader"></div>

    <div class="container py-3" *ngIf="activeTab==='upcoming' " infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollGrid()" [scrollWindow]="true" >

        <div *ngIf="shipmentPageData && shipmentPageData.length === 0 && !enableLoader" class="text-center strong  text-secondary my-5">
            {{'home.contracts.Noresults' | cxTranslate }}</div>
	<div *ngIf="shipmentPageData?.length>0 && !enableLoader">{{customText}}</div>
    <ng-container>
        <div class="card pt-3 pb-3 px-4 my-4 card-border border-radius-05" *ngFor="let shipdata of shipmentPageData">    <!----> 
        <div class="col">
            <div class="d-none d-lg-block">
                <div class="row">
                    <div class="row col-md-3 col-lg-3">
                        <div class="col-md-5 col-lg-6 mb-3">
                            <div class="small text-secondary">{{'shipment.ShipmentNo'| cxTranslate}}</div>
                            <div class="shipIdLabel">{{shipdata.shipmentId}}</div>
                        </div>
                        <div class="col-md-7 col-lg-6 mb-3 padRightFforPortName">
                            <div class=" small text-secondary">{{'shipment.LoadPort'| cxTranslate}}</div>
                            <div class="small" >{{shipdata.loadPort}}</div>
                        </div>
                        
                    </div>
                    <div class="col-md-2 mb-3 leftForDestination">
                        <div class=" small text-secondary ">{{'shipment.Destination'| cxTranslate}}</div>
                        <div class="small" >{{shipdata.destination}}</div>
                    </div>
                   
                    
                    <div class="col-md-2 mb-3" *ngIf="shipdata.shipmentName && (shipdata.commodityType=='CA' || shipdata.shipmentName=='NI ')">
                        <div class=" small text-secondary">{{'shipment.VesselName'| cxTranslate}}</div>
                        <div class="small">{{shipdata.shipmentName}}</div>
                    </div>
                    <div class="col-md-2 mb-3" *ngIf="shipdata.etd && (shipdata.commodityType=='CA' || shipdata.shipmentName=='NI ')">
                        <div class=" small text-secondary">{{'shipment.ETD'| cxTranslate}}</div>
                        <div >{{convertDate(shipdata.etd)}}</div>
                    </div>
                    <div class="col-md-2 mb-3" *ngIf="shipdata.etad && (shipdata.commodityType=='CA' || shipdata.shipmentName=='NI ')">
                        <div class="small text-secondary small">{{'shipment.ETAD'| cxTranslate}}</div>
                        <div class="small" >{{convertDate(shipdata.etad)}}</div>
                    </div>
                    <div class="ml-auto" *ngIf="shipdata.vesselNominationStatus == 'NOMINATED'">
                        <button [disabled]="isPlaceBidDisabled" class="btn btn-sm btn-primary strong" (click)="openNomination(shipdata.shipmentId,shipdata.vesselNominationStatus)">Review nominated vessel</button>
                    </div>
                    <div class="ml-auto" *ngIf="shipdata.vesselNominationStatus == 'ACCEPTED'">
                        <button [disabled]="isPlaceBidDisabled" class="btn btn-sm btn-success strong buttonclass" (click)="openNomination(shipdata.shipmentId,shipdata.vesselNominationStatus)">Vessel accepted</button>
                    </div>
                    <div class="ml-auto" *ngIf="shipdata.vesselNominationStatus == 'REJECTED'">
                        <button [disabled]="isPlaceBidDisabled" class="btn btn-sm btn-secondary strong buttonclass" (click)="openNomination(shipdata.shipmentId,shipdata.vesselNominationStatus)">Vessel rejected</button>
                    </div>
                </div>
            </div>
           
           
        </div>
        <div class=" d-lg-none ">
            <div class="d-flex flex-row justify-content-between">
                <div>
                    <div class="">
                        <div class="small text-secondary">{{'shipment.ShipmentNo'| cxTranslate}}</div>
                        <div class="shipIdLabel">{{shipdata.shipmentId}}</div>
                    </div>
                    <div class="" *ngIf="shipdata.shipmentName && (shipdata.commodityType=='CA' || shipdata.shipmentName=='NI ')">
                        <div class=" small text-secondary">{{'shipment.VesselName'| cxTranslate}}</div>
                        <div class="small">{{shipdata.shipmentName}}</div>
                    </div>
                </div>
               
                <div>
                    <div class="" *ngIf="shipdata.etd && (shipdata.commodityType=='CA' || shipdata.shipmentName=='NI ')">
                        <div class=" small text-secondary">{{'shipment.ETD'| cxTranslate}}</div>
                        <div >{{convertDate(shipdata.etd)}}</div>
                    </div>
                    <div class="" *ngIf="shipdata.etad && (shipdata.commodityType=='CA' || shipdata.shipmentName=='NI ')">
                        <div class="small text-secondary small">{{'shipment.ETAD'| cxTranslate}}</div>
                        <div class="small" >{{convertDate(shipdata.etad)}}</div>
                    </div>
                    <div class="ml-auto" *ngIf="shipdata.vesselNominationStatus == 'NOMINATED'">
                        <button [disabled]="isPlaceBidDisabled" class="btn btn-sm btn-primary strong" (click)="openNomination(shipdata.shipmentId,shipdata.vesselNominationStatus)">Review nominated vessel</button>
                    </div>
                    <div class="ml-auto" *ngIf="shipdata.vesselNominationStatus == 'ACCEPTED'">
                        <button [disabled]="isPlaceBidDisabled" class="btn btn-sm btn-success strong buttonclass" (click)="openNomination(shipdata.shipmentId,shipdata.vesselNominationStatus)">Vessel accepted</button>
                    </div>
                    <div class="ml-auto" *ngIf="shipdata.vesselNominationStatus == 'REJECTED'">
                        <button [disabled]="isPlaceBidDisabled" class="btn btn-sm btn-secondary strong buttonclass" (click)="openNomination(shipdata.shipmentId,shipdata.vesselNominationStatus)">Vessel rejected</button>
                    </div> 
                </div>  
            </div>
            <div class="d-flex flex-row justify-content-between mt-2">
                <div class="mb-3">
                    <div class=" small text-secondary">{{'shipment.LoadPort'| cxTranslate}}</div>
                    <div class="small" >{{shipdata.loadPort}}</div>
                </div>
                <div class="mb-3">
                    <div class=" small text-secondary ">{{'shipment.Destination'| cxTranslate}}</div>
                    <div class="small" >{{shipdata.destination}}</div>
                </div>
            </div>
        </div>
            <table>
                <thead role="rowgroup" >
                    <tr role="row" class="bg-table-header border-bottom ">
                        <th *ngIf="!(shipdata?.commodityType=='CA' || shipdata?.commodityType=='NI')" class=' p-7' width="10%">{{'shipment.loadPortLaycan' | cxTranslate}} </th>
                        <th class=' p-7' width="14%">{{'shipment.material' | cxTranslate}}</th>
                        <th class=' p-7' width="17%">{{'shipment.scheduleQty' | cxTranslate}} ({{shipdata?.shipmentWithProductEntries?.[0]?.scheduledQtyUom}})</th>
                        <th class=' p-7' width="12%">{{'shipment.shipTo' | cxTranslate}}</th>
                        <th class=' p-7' width="13%">{{'shipment.contractId' | cxTranslate}}</th>
                        <th class=' p-7' width="8%">{{'shipment.incoterms' | cxTranslate}}</th>
                        <th *ngIf="!(shipdata?.commodityType=='CA' || shipdata?.commodityType=='NI')"class=' p-7' width="35%">{{'shipment.remarks' | cxTranslate}}</th>
                        <th *ngIf="(shipdata?.commodityType=='CA' || shipdata?.commodityType=='NI')"class=' p-7' width="45%">{{'shipment.remarks' | cxTranslate}}</th>
                    </tr>
                    </thead>
                    <tbody role="rowgroup">
                        <tr role="row" *ngFor="let shipMaterial of shipdata.shipmentWithProductEntries;let i=index " >
                          <td *ngIf="!(shipdata?.commodityType=='CA' || shipdata?.commodityType=='NI')"  class=' p-7 small' [attr.data-label]="'shipment.loadPortLaycan' | cxTranslate" role="cell">{{shipMaterial.stringLaycanStartDate? shipMaterial.stringLaycanStartDate:'NA'}}-{{shipMaterial.stringLaycanEndDate? shipMaterial.stringLaycanEndDate:'NA'}}</td>
                          <td class=' p-7 small' [attr.data-label]="'shipment.material' | cxTranslate" role="cell">{{shipMaterial.productName?shipMaterial.productName:'NA'}}</td>
                          <td class=' p-7 small' [attr.data-label]="'shipment.scheduleQty' | cxTranslate" role="cell">{{shipMaterial.scheduledQty || '0' | number :"1.0"}}</td><!--{{shipMaterial.scheduledQty?shipMaterial.scheduledQty :'NA'}}-->
                          <td class=' p-7 small' [attr.data-label]="'shipment.shipTo' | cxTranslate" role="cell">{{shipMaterial.shipTo?shipMaterial.shipTo:'NA'}}</td>
                          <td class=' p-7 small' [attr.data-label]="'shipment.contractId' | cxTranslate" role="cell">{{shipMaterial.contractId?shipMaterial.contractId:'NA'}}</td>
                          <td class=' p-7 small' [attr.data-label]="'shipment.incoterms' | cxTranslate" role="cell">{{shipMaterial.incotermPart1?shipMaterial.incotermPart1:'NA'}}</td>
                          <td class=' p-7 small' [attr.data-label]="'shipment.remarks' | cxTranslate" role="cell">{{shipMaterial.remarks?shipMaterial.remarks:'NA'}}</td>
                        </tr>
                      </tbody>
            </table>
        </div>
    </ng-container>
    </div>
    
   
    <div class="container "  *ngIf="(activeTab==='inprogress' || activeTab === 'completed') && !enableLoader"  infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollGrid()" [scrollWindow]="true">
        <div *ngIf="shipmentPageData && shipmentPageData.length === 0 && !enableLoader" class="text-center strong  text-secondary my-5">
            {{'home.contracts.Noresults' | cxTranslate }}</div>
            
        <div *ngIf="grid==true">
            <div style="padding-top: 15px;" *ngIf="shipmentPageData?.length>0 && !enableLoader">{{customText}}</div>
       <!-- <div class="m-3 card" *ngFor="item of lists">-->
        <div class="row flex-wrap" >
            <div class="col-md-6 col-lg-4 "  *ngFor="let shipdata of shipmentPageData">
            <div class="card card-body mt-4 mb-4 p-3 border-radius-05">
                <div class="d-flex">
                <div class="badge badge-primary" *ngIf="shipdata && shipdata.shipmentStatus === 'VESSEL_SAILED'">{{shipdata && shipdata.shipmentStatusName.split("_   ").join(" ") }}</div>
                <div class="badge badge-secondary" *ngIf="shipdata && shipdata.shipmentStatus === 'BERTHED_AT_LOAD_PORT'">{{shipdata && shipdata.shipmentStatusName.split("_").join(" ") }}</div>
                <div class="badge badge-secondary" *ngIf="shipdata && shipdata.shipmentStatus === 'ARRIVED_AT_LOAD_PORT'">{{shipdata && shipdata.shipmentStatusName.split("_").join(" ") }}</div>
                <div class="badge badge-secondary" *ngIf="shipdata && shipdata.shipmentStatus === 'SHIPMENT_SCHEDULED'">{{shipdata && shipdata.shipmentStatusName.split("_").join(" ") }}</div>
                <div class="badge badge-success" *ngIf="shipdata && shipdata.shipmentStatus === 'ARRIVED_AT_DESTINATION'">{{shipdata && shipdata.shipmentStatusName.split("_").join(" ") }}</div>
                <div class="badge badge-primary" *ngIf="shipdata && shipdata.shipmentStatus === 'Open'">{{shipdata && shipdata.shipmentStatusName.split("_").join(" ") }}</div>
            </div >
                <hr>
                <div>
                    <div class="d-flex"> 
                        <img src="/images/Icon.svg" alt="icon" width="42" height="44">
                        <ul>
                        <li class="strong h5 mb-0" >{{shipdata && shipdata.shipmentName || '---'}}</li> 
                       <li class="small text-secondary small">{{'shipment.ShipmentNumber' | cxTranslate}}: {{shipdata && shipdata.shipmentId}}</li>
                        </ul>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="small text-secondary small">{{'shipment.loadPort' | cxTranslate}}</div>
                            <div class="strong small itenerary-location">{{shipdata && shipdata.loadPort}}</div>
                        </div>
                        <div class="col">
                            <div class="small text-secondary small">{{'shipment.destination' | cxTranslate}}</div>
                            <div class="strong small itenerary-location">{{shipdata && shipdata.destination}}</div>
                        </div>
                         <div class="col" *ngIf="shipdata?.purchaseOrderNo">
                         <div class="small text-secondary small">{{'shipment.purchaseOrderNo' | cxTranslate}}</div>
                        <div class="strong small itenerary-location">{{shipdata && shipdata.purchaseOrderNo}}</div>
                        </div>

                    </div>
                </div>
                <hr>
                <div class="row d-flex flex-wrap justify-content-between">
                    <div class="col dates"  *ngIf="shipdata && shipdata?.fobShipment==false">
                        <div class="small text-secondary small">{{'shipment.ETA' | cxTranslate}}</div>
                        <div class=" small">{{shipdata && shipdata.stringEta}}</div>
                    </div>
                    <div class="col dates">
                        <div class="small text-secondary small">{{'shipment.ETB' | cxTranslate}}</div>
                        <div class="small">{{shipdata && shipdata.stringEtb}}</div>
                    </div>
                    <div class="col dates">
                        <div class="small text-secondary small">{{'shipment.ETD' | cxTranslate}}</div>
                        <div class="small">{{shipdata && shipdata.stringEtd}}</div>
                    </div>
                    <div class="col dates">
                        <div class="small text-secondary small">{{'shipment.BOL' | cxTranslate}}</div>
                        <div class="small">{{shipdata && shipdata.stringBol}}</div>
                    </div>
                    <!-- <div class="col dates"  *ngIf="shipdata && shipdata?.fobShipment==false">
                        <div class="small text-secondary small">{{'shipment.ETAD' | cxTranslate}}</div>
                        <div class=" small">{{convertDate(shipdata && shipdata.etad)}}</div>
                    </div> -->
                </div>
                <hr>
                <div class="d-flex productList scrollable row">
                    <div class="col-3">
                        <div class="small text-secondary small">{{'shipment.Quantity' | cxTranslate}}</div>
                        <div *ngFor="let data of shipdata.shipmentWithProductEntries">
                            <div class="small" >{{data.actualQty || '0' | number :"1.0"}}</div>
                            <!--<div class="small" *ngIf="shipdata && shipdata.shipmentStatus === 'BERTHED_AT_LOAD_PORT' && data.scheduledQty!==undefined " >{{data.actualQty || '0' | number :"1.0"}}</div>
                            <div class="small" *ngIf="shipdata && shipdata.shipmentStatus === 'ARRIVED_AT_DESTINATION' && data.actualQty!==undefined " >{{data.actualQty || '0' | number :"1.0"}}</div>
                            <div class="small" *ngIf="shipdata && shipdata.shipmentStatus === 'VESSEL_SAILED'&& data.actualQty!==undefined " >{{data.actualQty || '0' | number :"1.0"}}</div>-->
                        </div>
                        <!-- <div class="small">{{shipmentPageData && shipmentPageData.shipmentWithProductEntries && shipmentPageData.shipmentWithProductEntries[0].quantity }}</div> -->
                    </div>
                    <div class="col-9">
                        <div class="small text-secondary small">{{'home.headerLinks.material' | cxTranslate}}</div>
                        <div class="small" *ngFor="let data of shipdata.shipmentWithProductEntries">{{data.productName}}</div>
                        <!-- <div class="small">{{shipmentPageData && shipmentPageData.shipmentWithProductEntries && shipmentPageData.shipmentWithProductEntries[0].productName}}</div> --> 
                    </div>
                </div>
                <hr>
                <div>
                    <div class="btn btn-link p-0  float" (click)="gotoDeatils(shipdata.shipmentId,shipdata.destination,shipdata.loadPort)">{{'shipment.documents&Details' | cxTranslate}} ></div>
                </div>
            </div>
            </div>
        </div>
        </div>
        <div *ngIf="list==true">
            <div class="pd-tp-bt" *ngIf="shipmentPageData?.length>0 && !enableLoader">{{customText}}</div>
            <div class="row flex-wrap">
                <div class="col-md-12 col-lg-12 " *ngFor="let shipdata of shipmentPageData">
                    <div class="card pt-3 pb-3 pl-4 pr-4 mb-4 card-border border-radius-05">
                        <div class="d-flex justify-content-between">
                            <div class='d-flex align-items-center'>
                                <div class="badge badge-primary" *ngIf="shipdata && shipdata.shipmentStatus === 'VESSEL_SAILED'">{{shipdata && shipdata.shipmentStatusName.split("_   ").join(" ") }}</div>
                                <div class="badge badge-secondary" *ngIf="shipdata && shipdata.shipmentStatus === 'BERTHED_AT_LOAD_PORT'">{{shipdata && shipdata.shipmentStatusName.split("_").join(" ") }}</div>
                                <div class="badge badge-secondary" *ngIf="shipdata && shipdata.shipmentStatus === 'ARRIVED_AT_LOAD_PORT'">{{shipdata && shipdata.shipmentStatusName.split("_").join(" ") }}</div>
                                <div class="badge badge-secondary" *ngIf="shipdata && shipdata.shipmentStatus === 'SHIPMENT_SCHEDULED'">{{shipdata && shipdata.shipmentStatusName.split("_").join(" ") }}</div>
                                <div class="badge badge-success" *ngIf="shipdata && shipdata.shipmentStatus === 'ARRIVED_AT_DESTINATION'">{{shipdata && shipdata.shipmentStatusName.split("_").join(" ") }}</div>                            
                            </div>
                        </div>
                        <div class="hr"></div>
                        <div class="inside-layout align-self-stretch">
                            <div class="py-2 d-none d-lg-block">
                                <div class="h5 mb-0 fw-bold">{{shipdata.shipmentName?shipdata.shipmentName:'--'}}</div>
                                <div class="small text-secondary">{{'shipment.ShipmentNumber' | cxTranslate}}: {{shipdata.shipmentId?shipdata.shipmentId:'--'}}</div>
                            </div>
                            <!-- Mobile view in progress/completed tab-->
                            <div class="d-flex py-2 d-lg-none">
                                <div>
                                    <img src="/images/Icon.svg"/>
                                </div>
                                <div class="ml-2">
                                    <div class="h5 mb-0 fw-bold">{{shipdata.shipmentName?shipdata.shipmentName:'--'}}</div>
                                    <div class="small text-secondary">{{'shipment.ShipmentNumber' | cxTranslate}}: {{shipdata.shipmentId?shipdata.shipmentId:'--'}}</div>
                                </div>
                            </div>
                            <!-- End  -->
                            <div class='d-flex py-2'>
                                <div class="d-none d-md-block d-lg-block">
                                    <div class="small text-secondary">{{'shipment.loadPort' | cxTranslate}}</div>
                                    <div class="small">{{shipdata.loadPort?shipdata.loadPort:'--'}}</div>
                                </div>
                                <div class="d-none d-md-block d-lg-block ml-5">
                                    <div class="small text-secondary">{{'shipment.destination' | cxTranslate}}</div>
                                    <div class="small">{{shipdata.destination?shipdata.destination:'--'}}</div>
                                </div>
                                   <div class="d-none d-md-block d-lg-block ml-5" *ngIf="shipdata && shipdata?.purchaseOrderNo">
                                    <div class="small text-secondary">{{'shipment.purchaseOrderNo' | cxTranslate}}</div>
                                    <div class="small">{{shipdata.purchaseOrderNo?shipdata.purchaseOrderNo:'--'}}</div>
                                </div>

                                <div class="d-none d-md-block d-lg-block ml-5" *ngIf="shipdata && shipdata?.fobShipment==false">
                                    <div class="small text-secondary">{{'shipment.ETA' | cxTranslate}}</div>
                                    <div class="small">{{shipdata && shipdata.stringEta}}</div>
                                </div>
                                <div class="d-none d-md-block d-lg-block ml-5">
                                    <div class="small text-secondary">{{'shipment.ETB' | cxTranslate}}</div>
                                    <div class="small">{{shipdata && shipdata.stringEtb}}</div>
                                </div>
                                <div class="d-none d-md-block d-lg-block ml-5">
                                    <div class="small text-secondary">{{'shipment.ETD' | cxTranslate}}</div>
                                    <div class="small">{{shipdata && shipdata.stringEtd}}</div>
                                </div>
                                <div class="d-none d-md-block d-lg-block ml-5">
                                    <div class="small text-secondary">{{'shipment.BOL' | cxTranslate}}</div>
                                    <div class="small">{{shipdata && shipdata.stringBol}}</div>
                                </div>
                                <!-- <div class="d-none d-md-block d-lg-block ml-5" *ngIf="shipdata && shipdata?.fobShipment==false">
                                    <div class="small text-secondary">{{'shipment.ETAD' | cxTranslate}}</div>
                                    <div class="small">{{convertDate(shipdata && shipdata.etad)}}</div>
                                </div> -->
                                <div class="d-md-none d-lg-none">
                                    <div class=" small text-secondary">{{'shipment.loadPort' | cxTranslate}}</div>
                                    <div class="small bold">{{shipdata.loadPort?shipdata.loadPort:'--'}}</div>
                                </div>
                                <div class='d-md-none d-lg-none ml-5'>
                                    <div class="small text-secondary">{{'shipment.destination' | cxTranslate}}</div>
                                    <div class="small bold">{{shipdata.destination?shipdata.destination:'--'}}</div>
                                </div>
                            </div>                            
                        </div>
                         <!-- Mobile View In progress/completed tab -->
                        <div class="hr d-lg-none"></div>
                           
                            <div class="d-flex py-2 d-lg-none justify-content-between">
                                <div class="" *ngIf="shipdata && shipdata?.fobShipment==false">
                                    <div class="small text-secondary">{{'shipment.ETA' | cxTranslate}}</div>
                                    <div class="small bold">{{shipdata && shipdata.stringEta}}</div>
                                </div>
                                <div class="">
                                    <div class="small text-secondary">{{'shipment.ETB' | cxTranslate}}</div>
                                    <div class="small bold">{{shipdata && shipdata.stringEtb}}</div>
                                </div>
                                <div class="">
                                    <div class="small text-secondary">{{'shipment.ETD' | cxTranslate}}</div>
                                    <div class="small bold">{{shipdata && shipdata.stringEtd}}</div>
                                </div>
                                <div class="">
                                    <div class="small text-secondary">{{'shipment.BOL' | cxTranslate}}</div>
                                    <div class="small bold">{{shipdata && shipdata.stringBol}}</div>
                                </div>
                            </div>
                            <!-- <div class="hr d-lg-none"></div> -->

                            <!-- End Mobile view  -->
                        <div class="hr"></div>
                        <div class="inside-layout  align-self-stretch">
                            <div class="d-none d-md-block d-lg-block">
                                <div class="strong text-primary pe-auto" (click)="gotoDeatils(shipdata.shipmentId,shipdata.destination,shipdata.loadPort)">
                                    {{'shipment.documents&Details' | cxTranslate}} ></div>
                            </div>
                            <div>
                            </div>
                            <div class="d-md-none d-lg-none ">
                                <div class="strong text-primary pe-auto" (click)="gotoDeatils(shipdata.shipmentId,shipdata.destination,shipdata.loadPort)">
                                    {{'shipment.documents&Details' | cxTranslate}} ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    </div>        
    </section>  
<div class="py-4 container">
</div>

